import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';
import queryString from 'query-string';

// Loader Components
import showLoader from '@components/loader';

export const getTrips = createAsyncThunk('historySlice/getTrips', async (data) => {
    try {
        const query = queryString.stringify(data);

        showLoader(true);
        let response = await axios.get('/vehicle-trips?' + `&${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data.data.rows);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getMongoTrips = createAsyncThunk('historySlice/getMongoTrips', async (data) => {
    try {
        const query = queryString.stringify(data);

        showLoader(true);
        let response = await axios.get('/mongo-vehicle-trip?' + `${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data.data.rows);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getSingleTrip = createAsyncThunk('historySlice/getSingleTrip', async (id) => {
    try {
        showLoader(true);
        let response = await axios.get('/vehicle-trips/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getSingleMongoTrip = createAsyncThunk('historySlice/getSingleMongoTrip', async (id) => {
    try {
        showLoader(true);
        let response = await axios.get('/mongo-vehicle-trips/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const historySlice = createSlice({
    name: 'historySlice',
    initialState: {
        data: [],
        tripData: [],
        option: []
    },
    reducers: {
        clearTripData: (state) => {
            state.tripData = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getTrips.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        }),
            builder.addCase(getSingleMongoTrip.fulfilled, (state, action) => {
                state.tripData = action.payload;
                return;
            });
    }
});
export const { clearTripData } = historySlice.actions;
export default historySlice.reducer;
